import { render, staticRenderFns } from "./LearningTools.vue?vue&type=template&id=3763031a&scoped=true&"
import script from "./LearningTools.vue?vue&type=script&lang=js&"
export * from "./LearningTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763031a",
  null
  
)

export default component.exports